export default "__VITE_ASSET__CNcY6Zx0__"